(function(){
  window.PCCLab = window.PCCLab || {};
  var gsapPromise = null;

  function loadScript(src){
    return new Promise(function(resolve, reject){
      var s = document.createElement('script');
      s.src = src; s.async = true;
      s.onload = resolve; s.onerror = reject;
      document.head.appendChild(s);
    });
  }

  window.PCCLab.loadGSAP = function(){
    if (gsapPromise) return gsapPromise;
    gsapPromise = Promise.resolve()
      .then(function(){
        if (typeof window.gsap === 'undefined') {
          return loadScript('https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/gsap.min.js');
        }
      })
      .then(function(){
        if (typeof window.ScrollTrigger === 'undefined') {
          return loadScript('https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/ScrollTrigger.min.js');
        }
      })
      .then(function(){
        if (!window.gsap || !window.ScrollTrigger) throw new Error('gsap failed to load');
        window.gsap.registerPlugin(window.ScrollTrigger);
        return window.gsap;
      });
    return gsapPromise;
  };

  window.PCCLab.prefersReduced = function(){
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  };

  window.PCCLab.isDesktop = function(){
    return !!(window.matchMedia && window.matchMedia('(min-width: 900px)').matches);
  };

  // Enhance a section: only attempts GSAP pin/scrub choreography on desktop
  // with motion allowed. Everyone else keeps the static/simple fallback that
  // is already in the DOM by default.
  window.PCCLab.enhance = function(initFn){
    if (window.PCCLab.prefersReduced() || !window.PCCLab.isDesktop()) return;
    window.PCCLab.loadGSAP().then(initFn).catch(function(){ /* fallback stays visible */ });
  };

  // Lightweight IntersectionObserver reveal used for mobile / simplified
  // choreography so mobile never just sits static and lifeless.
  window.PCCLab.revealOnView = function(el, activeClass, threshold){
    if (!el) return;
    if (window.PCCLab.prefersReduced() || !('IntersectionObserver' in window)) {
      el.classList.add(activeClass);
      return;
    }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (e.isIntersecting) { el.classList.add(activeClass); io.disconnect(); }
      });
    }, { threshold: threshold || 0.25 });
    io.observe(el);
  };
})();
